// axios
import axios from "axios";
import store from "@/store/store";
import Crypto from "@/helper/crypto";

const baseURL = "";

axios.interceptors.request.use(
  function(config) {
    config.headers = {
      Locale: store.state.appUser.locale,
      Country: store.state.appUser.selectedCountryCode,
      "Platform-Type": "Web",
      "Secret-Key": process.env.MIX_APP_SECRET,
    };

    const token = store.state.appUser.token;
    if (token) {
      config.headers.Authorization = "Bearer " + Crypto.decrypt(token);
    }
    return config;
  },
  function(err) {
    return Promise.reject(err);
  }
);

let instance = axios;

export default instance;
